import * as React from "react";
import { Link } from "react-router-dom";
import { IconButton, Menu, MenuItem, TableCell, TableRow, Checkbox, } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { MoreVert } from "@material-ui/icons";
import { red } from "@material-ui/core/colors";
import { useConfirmationDialog } from "frontend/src/ui/dialog";
import { useClient, } from "frontend/src/domain/client";
import { usePlaylistDetail, } from "frontend/src/domain/playlists";
import { useDeleteMusicArchive } from "frontend/src/domain/music-archives/actions";
import { paths } from "frontend/src/pages/paths/index";
var useStyles = makeStyles({
    remove: {
        color: red[700],
    },
});
export var MusicArchivesTableRow = function (_a) {
    var _b, _c, _d;
    var id = _a.id, clientId = _a.clientId, playlistId = _a.playlistId, isProcessing = _a.isProcessing, isReady = _a.isReady, filename = _a.filename, isChecked = _a.isChecked, setIsChecked = _a.setIsChecked;
    var classes = useStyles();
    var _e = React.useState(null), anchor = _e[0], setAnchor = _e[1];
    var handleClick = function (event) {
        setAnchor(event.currentTarget);
    };
    var close = function () { return setAnchor(null); };
    var client = (clientId ? useClient(clientId) : { data: null }).data;
    var _f = usePlaylistDetail(playlistId), playlist = _f.playlist, playlistIsLoading = _f.isLoading;
    var status = (isReady
        ? 'готов'
        : (isProcessing
            ? 'создаётся'
            : 'запланирован'));
    var remove = useDeleteMusicArchive();
    var clientTitle = client
        ? [client.contractNumber, (_b = client.russianLegalEntity) === null || _b === void 0 ? void 0 : _b.title].filter(Boolean).join(" / ")
        : "Все клиенты";
    var _g = useConfirmationDialog({
        message: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0430\u0440\u0445\u0438\u0432 \u043F\u043B\u0435\u0439\u043B\u0438\u0441\u0442\u0430 \"" + ((_c = playlist === null || playlist === void 0 ? void 0 : playlist.title) !== null && _c !== void 0 ? _c : '—') + "\"?",
        onConfirm: function () { return remove.do(id); },
        open: false,
    }), open = _g.open, Dialog = _g.Dialog;
    var checkboxOnChange = function (evt) {
        setIsChecked(id);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(TableRow, null,
            React.createElement(TableCell, null,
                React.createElement(Checkbox, { checked: isChecked, onChange: checkboxOnChange, name: "published", color: "primary" })),
            React.createElement(TableCell, null, id),
            React.createElement(TableCell, null, (_d = playlist === null || playlist === void 0 ? void 0 : playlist.title) !== null && _d !== void 0 ? _d : "--"),
            React.createElement(TableCell, null, clientTitle),
            React.createElement(TableCell, null, status),
            React.createElement(TableCell, null,
                React.createElement(IconButton, { size: "small", onClick: handleClick },
                    React.createElement(MoreVert, null)),
                React.createElement(Menu, { anchorEl: anchor, keepMounted: true, open: Boolean(anchor), onClose: close },
                    React.createElement(MenuItem, { component: Link, to: paths.admin.musicArchives.edit(id) }, "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C"),
                    React.createElement(MenuItem, { className: classes.remove, onClick: function () {
                            open();
                            close();
                        } }, "\u0423\u0434\u0430\u043B\u0438\u0442\u044C")))),
        React.createElement(Dialog, null)));
};
